import { Skeleton } from './Skeleton';
import { SkeletonCircle } from './SkeletonCircle';

/**
 * Skeleton for account page sections.
 */
export const AccountSkeleton = () => {
  return (
    <div className="min-h-screen bg-canvas py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto space-y-8">
        {/* Header Section */}
        <div className="text-center space-y-4">
          <Skeleton className="h-6 w-48 mx-auto" />
          <Skeleton className="h-12 w-64 mx-auto" />
          <Skeleton className="h-6 w-96 mx-auto" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
          {/* Left Column: Stats & Identity */}
          <div className="lg:col-span-5 space-y-6">
            {/* Stats Card */}
            <div className="bg-surface rounded-2xl p-6 shadow-sm ring-1 ring-gray-900/5">
              <Skeleton className="h-6 w-32 mb-4" />
              <div className="grid grid-cols-2 gap-4">
                {[1, 2, 3, 4].map((i) => (
                  <div key={i} className="space-y-2">
                    <Skeleton className="h-8 w-16" />
                    <Skeleton className="h-4 w-20" />
                  </div>
                ))}
              </div>
            </div>

            {/* Profile Identity Card */}
            <div className="bg-surface rounded-2xl p-6 shadow-sm ring-1 ring-gray-900/5">
              <div className="flex flex-col items-center space-y-4">
                <SkeletonCircle size="w-32 h-32" />
                <Skeleton className="h-10 w-full" />
                <Skeleton className="h-20 w-full" />
                <Skeleton className="h-10 w-full rounded-full" />
              </div>
            </div>
          </div>

          {/* Right Column: Settings */}
          <div className="lg:col-span-7 space-y-6">
            {/* Security Section */}
            <div className="bg-surface rounded-2xl p-6 shadow-sm ring-1 ring-gray-900/5">
              <Skeleton className="h-6 w-40 mb-4" />
              <div className="space-y-4">
                <Skeleton className="h-12 w-full" />
                <Skeleton className="h-10 w-32 rounded-full" />
              </div>
            </div>

            {/* Danger Zone */}
            <div className="bg-surface rounded-2xl p-6 shadow-sm ring-1 ring-gray-900/5">
              <Skeleton className="h-6 w-32 mb-4" />
              <Skeleton className="h-10 w-40 rounded-full" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
